/* tslint:disable:typedef-whitespace no-trailing-whitespace no-inferrable-types import-spacing */

import { ElementRef }         from '@angular/core';

import { Dialog }             from './dialog';
import { Logger }             from '@/util/logger';

import { IValidatorCallBack } from './i.validator.call.back';
import { IOkCallBack        } from './i.ok.call.back';

import * as $                 from 'jquery';
import 'jquery-ui-dist/jquery-ui';
import {ServiceManager} from '@/services/service.manager';
import {ServiceLocator} from '@/services/service.locator';
import {FAVRecord} from '@/models/project/f.a.v.record';
import { OperationalMeasureDialogParams } from './operational.measure.dialog.params';

/**
 *
 * @class NewOperationalMeasureDialog
 *
 * Dialog for gathering parameters needed to create an operational measure model via BigQuery and
 * the locoquery service.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2022
 *
 */
export class NewOperationalMeasureDialog extends Dialog {

  /** the name we're trying get from the user */
  // private name;

  /** the corridor we're trying get from the user */
  private corridor: string  = '';

  /** the start of the time bound */
  private start: string  = '';

  /** the end of the time bound */
  private end: string    = '';

  /** timer to wait for user to stop typing */
  private typingTimer = null;

  /** standard constructor */
  constructor(host: ElementRef) {

    super(host);

    this.title = 'New Historic Stringline/New Operational Measure';
    this.icon  = '<i class="fas fa-plus"></i>';

    Logger.debug('[NewOperationalMeasureDialog] setting up...');
  }

  /** dialog has been opened */
  public open(validator?: IValidatorCallBack, success?: IOkCallBack, options?: any) {

    let nomd: NewOperationalMeasureDialog = this;

    this.validator = validator ? validator : null;
    this.success   = success   ? success   : null;

    if (this.typingTimer) {

      clearTimeout(this.typingTimer);

      this.typingTimer = null;
    }

    Logger.debug('[NewOperationalMeasureDialog] opening...');

    this.corridor = '';

    const body = $(this.host).find('.modal-body');

    const html = `
<div id="locomotive-fav-field" style="margin-top: 12px;">
  <label class="gui-label" style="width: 120px;">Select Corridor:</label>

  <select class="gui-input locomotive-fav-input fav-select"><option></option></select>
</div>


<div id="locomotive-start-field" style="margin-top: 12px;">
  <label class="gui-label" style="text-align: right; width: 60px;">Start:</label>
  <input class="gui-input locomotive-start-input" style="width: 200px;" type="text" placeholder="...">
</div>

<div id="locomotive-end-field" style="margin-top: 12px;">
  <label class="gui-label" style="text-align: right; width: 60px;">End:</label>
  <input class="gui-input locomotive-end-input" style="width: 200px;" type="text" placeholder="...">
</div>

<div class="gui-error-line"></div>
    `;

    $(body).html(html);

    /* set the start picker */

    $('.locomotive-start-input').datepicker({

      dateFormat: 'yy-mm-dd',

      changeMonth: true,
      changeYear: true,

      onSelect: (date) => {

        /* jQuery datepicker uses format */

        Logger.debug(`[NewOperationalMeasureDialog] new start: `, date);

        nomd.start = date;

        this.validate();
      }

    });

    /* set the end picker */

    $('.locomotive-end-input').datepicker({

      dateFormat: 'yy-mm-dd',

      changeMonth: true,
      changeYear: true,

      onSelect: (date) => {

        Logger.debug(`[NewOperationalMeasureDialog] new end: `, date);

        nomd.end = date;

        this.validate();
      }

    });

    /* set up the FAV selection drop down */

    $('.fav-select').select2({

      placeholder:   `Please Wait...`,
      disabled:      true,
      allowClear:    false,
      closeOnSelect: true,
      width:         '200px',
      data:          []
    });

    /* add behaviors */

    setTimeout(() => {

      $(this.host).find('.opmeasure-name-input').focus();

      $(this.host).find('.opmeasure-name-input').on('input', (e) => {

        /* typing wait: @link https://stackoverflow.com/questions/10124114/wait-for-function-till-user-stops-typing */

        if (this.typingTimer) {

          clearTimeout(this.typingTimer);
        }

        this.typingTimer = setTimeout(() => {

          this.corridor = ($(e.currentTarget).val() as string).trim();

          this.validate();

        }, 400);

      });

      $(this.host).find('.opmeasure-name-input').on('keypress', (e) => {

        if (this.typingTimer) {

          clearTimeout(this.typingTimer);
        }

        this.typingTimer = setTimeout(() => {

          this.corridor = ($(e.currentTarget).val() as string).trim();

          if (e.key.toLowerCase() === 'enter') {

            this.validate(true);

            /* stop event propagation */

            return false;
          }

        }, 400);

      });

    }, 50);

    /* disable the Ok button...until we have valid input */

    this.validate();

    /* launch the data fill for the select2 dropdown (the FAV picker) */

    let sm: ServiceManager            = ServiceLocator.injector.get(ServiceManager);
    // sm.databridge.favList().then(
    sm.locoquery.corridorList().then(
      (result: string[]) => {

        Logger.debug(`[NewOperationalMeasureDialog] configuring drop down: `, result);

        /*
         * format the data per select2 needs ...
         *
         * https://select2.org/data-sources/formats
         *
         */

        let data: any[] = [];

        result.forEach((item: string) => {

          data.push({
            "id": item,
            "text": item,
            "corridor": item
          });

        });

        /* sort the data by name ... */

        //data.sort((a, b) => {

        //  return a.text.localeCompare(b.text);
        //});

        /* set the combo box to this set of data */

        $('.fav-select').select2('destroy');

        $('.fav-select').select2({

          placeholder: `Select...`,
          disabled: false,
          allowClear: false,
          closeOnSelect: true,
          width: '200px',
          data
        });

        /* should be good to go for selecting... */

        $('.fav-select').on('select2:select', (e) => {

          nomd.corridor = e.params.data['corridor'];

          Logger.debug('[NewOperationalMeasureDialog] Corridor picked: ', e.params.data['corridor']);

          this.validate();
        });

      },
      (error) => {

        Logger.error("[NewOperationalMeasureDialog] could not fetch Corridor list: ", error);



      });
  }

  disable() {

    const ok = $(this.host).find('.modal-ok-button');

    $(ok).attr('disabled', 'true');
    $(ok).addClass('disabled');
  }

  enable() {

    const ok = $(this.host).find('.modal-ok-button');

    $(ok).removeAttr('disabled');
    $(ok).removeClass('disabled');

  }

  /** show a validation error */
  error(msg: string) {

    const display = $(this.host).find('.gui-error-line');

    $(display).html(msg);
  }

  /* don't enable the Ok button until we have what we need. */
  validate(transition: boolean = false) {

    let nomd: NewOperationalMeasureDialog = this;

    nomd.error('');

    /* assume its bad */

    nomd.disable();

    if (!this.validator) {

      /* at least make sure the name isn't empty */

      if (nomd.corridor === null) {

        const display = $(nomd.host).find('.gui-error-line');

        $(display).html('Must select a Corridor');

        return ;
      }

      if (nomd.start === '') {

        const display = $(this.host).find('.gui-error-line');

        $(display).html('Must select a start date');

        return ;
      }

      if (nomd.end === '') {

        const display = $(this.host).find('.gui-error-line');

        $(display).html('Must select an end date');

        return ;
      }

      this.enable();

      /* if we make it through validation checks, and we're allowed to transition, then do it. */

      if (transition) {

        /* click the ok button for them, and trigger via ModelComponent */

        const ok = $(this.host).find('.modal-ok-button');

        $(ok).click();
      }

    } else {

      /* wrap validation in a promise, so it's ok if its asynchronous */

      const p = new Promise((resolve, reject) => {

        nomd.validator(new OperationalMeasureDialogParams({
          corridor:  nomd.corridor,
          start:     nomd.start,
          end:       nomd.end
         }),
         resolve,
         reject
        );

      }).then((value: OperationalMeasureDialogParams) => {

        nomd.enable();

        nomd.corridor = value.corridor;
        //nomd.start = value.start;
        //nomd.end = value.end;

        if (transition) {

          /* click the ok button for them, and trigger via ModelComponent */

          const ok = $(this.host).find('.modal-ok-button');

          $(ok).click();
        }

      }).catch((error) => {

        /* show the validation error */

        nomd.error(error);

      });

    }

  }

  /** dialog is closing */
  public close() {

    Logger.debug('[NewOperationalMeasureDialog] closing...');
  }

  /** dialog was accepted */
  public ok() {

    Logger.debug('[NewOperationalMeasureDialog] accepted: ', this.corridor);

    if (this.success) {

      /* inform the client */

      this.success({corridor: this.corridor, start: this.start, end: this.end});
    }

  }
}


